import { useContext, useEffect } from 'react';
import { UserContext } from 'commons-ui';

const Logout = () => {
	const { logoutUser } = useContext(UserContext);

	useEffect(() => {
		logoutUser();
		window.location.href = '/login';
	}, [logoutUser]);

	return null;
};

export default Logout;
